/**
 * Resolves a human-readable language name for a locale code via Intl.DisplayNames,
 * localized into displayLocale. Falls back to English, then to the raw code.
 * @param {string} code - Language code, e.g. 'cs' or 'pt_BR'.
 * @param {string} [displayLocale='en'] - UI locale to render the name in.
 * @returns {string} The language name, or '' when no code is given.
 */
export const getLanguageDisplayName = (code, displayLocale = 'en') => {
  if (!code) return '';
  const normalizedCode = code.replace(/_/g, '-');
  const resolve = loc => {
    try {
      return new Intl.DisplayNames([loc], { type: 'language' }).of(
        normalizedCode
      );
    } catch {
      return null;
    }
  };
  return (
    resolve((displayLocale || 'en').replace(/_/g, '-')) || resolve('en') || code
  );
};
